// ─────────────────────────────────────────────────────────────
//  Vrstvenie prekrytí (z-index) — JEDNO počítadlo pre Modal aj Sheet
// ─────────────────────────────────────────────────────────────
// Problém, ktorý to rieši: `.bz-scrim` (ds/Sheet) aj `.bz-modal-scrim` (ui/Modal) mali v CSS
// natvrdo `z-index: 300`. Pri VNORENÍ (detail výzvy → chat → detail reakcií) tak o poradí
// rozhodovalo len poradie uzlov v <body> (oba sa portálujú), nie zámer — a vnorené prekrytie
// sa vedelo otvoriť POD tým, z ktorého vzišlo.
//
// Riešenie je systémové (nie záplata na jeden prípad): každé otvorené prekrytie si pri mountnutí
// vypýta ĎALŠIU hladinu a pri unmountnutí ju vráti. Hladina → z-index cez `overlayZ`; hodnota ide
// do CSS premennej `--bz-overlay-z`, ktorú obe scrim triedy čítajú (fallback = OVERLAY_BASE_Z,
// takže bez JS sa nič nezmení).
//
// Rozsah je zámerne úzky (300–316), aby sa NEDOSTAL nad prekrytia, ktoré majú byť ešte vyššie:
// oslava dňa `.bz-dayring-scrim` (320) / jej konfety (330) a celoobrazovkové efekty `.bz-cfx` (400).
// Spodné vrstvy appky (FAB 50, spodná nav 50, číselníky 60/61) ostávajú hlboko pod nami.

export const OVERLAY_BASE_Z = 300;   // musí sedieť s .bz-scrim / .bz-modal-scrim v CSS
export const OVERLAY_STEP_Z = 2;     // krok medzi hladinami
export const OVERLAY_MAX_LEVEL = 9;  // strop: 300 + 8×2 = 316 < 320 (.bz-dayring-scrim)

// Obsadené hladiny v poradí otvorenia. Prázdne pole = žiadne otvorené prekrytie, takže po
// zavretí všetkého sa začína zase od 1 (hladiny sa NEHROMADIA).
const _levels: number[] = [];

/** Vypýtaj si hladinu pre práve otvárané prekrytie (vždy nad všetkými otvorenými). */
export function acquireOverlayLevel(): number {
  const level = _levels.length ? Math.max(..._levels) + 1 : 1;
  _levels.push(level);
  return level;
}

/** Vráť hladinu pri zatvorení prekrytia. Neznáma/už vrátená hladina je no-op. */
export function releaseOverlayLevel(level: number): void {
  const i = _levels.indexOf(level);
  if (i >= 0) _levels.splice(i, 1);
}

/** Hladina → z-index (orezané na OVERLAY_MAX_LEVEL, nech nikdy neprelezieme nad oslavu dňa). */
export function overlayZ(level: number): number {
  const lvl = Math.min(Math.max(level | 0, 1), OVERLAY_MAX_LEVEL);
  return OVERLAY_BASE_Z + (lvl - 1) * OVERLAY_STEP_Z;
}

/** Koľko prekrytí je práve otvorených (pre testy a ladenie). */
export function openOverlayCount(): number {
  return _levels.length;
}
